import { makeObservable, runInAction, computed, action, observable } from "mobx"
import { AbsLoopsModel } from '../loops/model'
import { fetchPresets, fetchMyLoops } from './PackAPI'

class PackLoopsModel extends AbsLoopsModel {

  pack = null

  constructor() {
    super()
    makeObservable(this, {
      load: action,
      id: computed,
      toMyLoops: action,
      setPackId: action,
      pack: observable
    })
    this.loopState = 'presets'
  }

  get id() {
    return this.packId;
  }

  setPackId = (id) => {
    this.packId = id
  }

  setPack = (pack) => {
    this.pack = pack
  }

  load = async () => {
    this.loading = true
    try {
      const fetchData = this.loopState === 'presets' ? fetchPresets : fetchMyLoops
      const loopsData = await fetchData({packId: this.packId, ...this.queryParams})
      this.setLoopsData(loopsData)
    } finally {
      runInAction(() => this.loading = false)
    }
  }

  toMyLoops = () => {
    // 必须单独执行load
    this.reset()
    this.loopState = 'myloops'
    this.load()
  }
}

// class PackModel {

//   id = null

//   config = null

//   pack = null

//   constructor({id}) {
//     makeAutoObservable(this)
//     this.id = id
//   }

//   load = async() => {
//     /// json
//   }

//   loadConfig = async() => {
    
//   }
// }

export { PackLoopsModel }